export default __webpack_public_path__ + "static/media/quiz1.b55d51bb.png";